import { useAccount, useMsal } from "@azure/msal-react";
import { Button, Modal, Stack, Text, Textarea } from "@mantine/core";
import { useState } from "react";
import { postAPI } from "src/utils/fetch";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export default function DatasourceRequestAccessModal({
    opened,
    onClose,
    onSubmit,
    title,
    description,
    ingestion_status,
    requested_datasources,
}) {
    const [requestReason, setRequestReason] = useState<string>("");
    const account = useAccount();
    const { instance } = useMsal();
    const [isSubmittingRequest, setIsSubmittingRequest] = useState(false);
    const submitAccessRequest = async () => {
        if (!account || !requestReason.trim()) return;

        setIsSubmittingRequest(true);
        try {
            const response = await postAPI({
                url: `${BACKEND_URL}/v1/user/access-requests`,
                payload: {
                    user_id:
                        account.idTokenClaims?.gid ||
                        account.idTokenClaims?.SCGID ||
                        account.idTokenClaims?.siemens_gid ||
                        account.localAccountId,
                    user_email: account.username,
                    requested_datasources: requested_datasources,
                    reason: requestReason,
                },
                instance,
            });

            if (response.ok) {
                setRequestReason("");
                onSubmit();
                onClose();
            } else {
                console.error("Failed to submit access request");
            }
        } catch (error) {
            console.error("Error submitting access request:", error);
        } finally {
            setIsSubmittingRequest(false);
        }
    };
    return (
        <Modal
            size="lg"
            opened={opened}
            onClose={onClose}
            title={title}
            closeButtonProps={{ "aria-label": "Close modal" }}
        >
            <Stack>
                {description && (
                    <Text size="sm">
                        <strong>Description:</strong> {description}
                    </Text>
                )}
                {ingestion_status && (
                    <Text size="sm">
                        <strong>Ingestion Status:</strong> {ingestion_status}
                    </Text>
                )}
            </Stack>
            <Stack align="flex-end" mt="md">
                <Textarea
                    placeholder="Please explain why you need access to this data source..."
                    value={requestReason}
                    onChange={(e) => setRequestReason(e.target.value)}
                    style={{ width: "100%" }}
                    minRows={4}
                    required
                />
                <Button
                    aria-label="Submit Request"
                    loading={isSubmittingRequest}
                    onClick={submitAccessRequest}
                    disabled={!requestReason.trim()}
                >
                    Submit Request
                </Button>
            </Stack>
        </Modal>
    );
}
